// extracted by mini-css-extract-plugin
module.exports = {"step":"step-card_step__mFUiv","stepNumber":"step-card_stepNumber__LS_o0","stepTitle":"step-card_stepTitle__WvMGz"};